const destinations = {
  bot: {
    title: "1. إعداد بوت تيليجرام",
    description: "تستخدم قنوات ومجموعات الوجهة بيانات اعتماد خاصة لبوت تيليجرام مرتبطة بحسابك الحالي. لا تُعاد الرموز المحفوظة إلى المتصفح ولا تُشارك مع مستخدمين آخرين.",
    tokenLabel: "رمز بوت تيليجرام",
    placeholderNew: "123456789:ABCdefGhIJKlmNoPQRsTUVwxyZ",
    placeholderReplace: "أدخل رمزًا جديدًا لاستبدال بيانات الاعتماد المحفوظة",
    save: "حفظ الرمز",
    saving: "جارٍ الحفظ",
    showToken: "إظهار رمز البوت",
    hideToken: "إخفاء رمز البوت",
    stored: "محفوظ بأمان",
    notConfigured: "الرمز غير مُعد",
    acquirePrefix: "احصل على رمز من",
    acquireSuffix: "يؤدي الحفظ إلى تخزين أو استبدال بيانات اعتماد حسابك فقط في Supabase Vault.",
  },
  targets: {
    title: "2. قنوات ومجموعات الوجهة",
    description: "أدر قنواتك ومجموعاتك العامة أو الخاصة على تيليجرام. لا يمكن إلا لحسابك الحالي عرض هذه الوجهات أو تعديلها أو اختبارها أو النشر إليها.",
    friendlyName: "اسم واضح",
    friendlyNamePlaceholder: "مثال: Tech Announcements",
    channelId: "معرّف القناة أو اسم المستخدم",
    channelIdPlaceholder: "مثال: @my_channel أو -100123456",
    add: "إضافة",
    addTarget: "إضافة وجهة",
    emptyTitle: "لم تتم إضافة وجهات بعد",
    emptyDescription: "أضف قناة أو مجموعة وجهة باسم واضح باستخدام النموذج أعلاه.",
    active: "نشط",
    muted: "معطّل",
    toggle: "تبديل الحالة النشطة للوجهة {{name}}",
    connected: "متصل",
    failed: "فشل",
    test: "اختبار الاتصال",
    testing: "جارٍ اختبار الاتصال",
    remove: "إزالة الوجهة {{name}}",
  },
  feedback: {
    verificationSuccessful: "تم التحقق بنجاح",
    verificationFailed: "فشل التحقق",
    saveTokenFirst: "احفظ رمز بوت تيليجرام بأمان قبل اختبار الوجهة.",
    verificationFallback: "فشل التحقق.",
    testPublished: "تم التحقق! نُشرت رسالة اختبار إلى {{channelId}}.",
    connectionFallback: "فشل الاتصال. تحقق من رمز البوت وصلاحيات المسؤول.",
    networkError: "حدث خطأ غير متوقع في الشبكة.",
    enterToken: "أدخل رمز بوت تيليجرام قبل الحفظ.",
    tokenStored: "تم حفظ رمز البوت بأمان لحسابك.",
    tokenSaveFailed: "تعذر حفظ رمز البوت. حاول مرة أخرى.",
    targetNameRequired: "أدخل اسمًا واضحًا للوجهة.",
    channelIdRequired: "أدخل معرّف قناة تيليجرام أو اسم المستخدم.",
  },
  guide: {
    title: "دليل الوجهات المتعددة",
    intro: "قم بإعداد بوتك الخاص لبث المحتوى المنسق إلى وجهاتك. يمتلك مستخدمو TGReposter الآخرون بيانات اعتماد وقوائم وجهات منفصلة.",
    adminTitle: "منح صلاحيات المسؤول",
    adminDescription: "يجب إضافة البوت كمسؤول في كل قناة أو مجموعة وجهة، مع منحه صلاحية «نشر الرسائل».",
    privateTitle: "دعم القنوات الخاصة",
    privateDescriptionPrefix: "للقنوات الخاصة، احصل على معرّف القناة الرقمي (يبدأ عادةً بـ",
    privateDescriptionSuffix: ") عبر إعادة توجيه منشور من القناة إلى بوت تشخيصي مثل",
    multiTitle: "تدفق النشر المتعدد",
    multiDescription: "عند النشر من صندوق المحتوى، يرسل الخادم الرسالة إلى كل وجهة نشطة ومحددة.",
    footer: "تعمل جميع الوجهات بالتوازي. إذا كانت إحدى الوجهات غير متاحة مؤقتًا أو تفتقر إلى الصلاحيات، يمكن لبقية الوجهات النشطة الاستمرار في استلام المنشور.",
  },
} as const;

export default destinations;
